import Polygon = require("esri/geometry/Polygon");
import Graphic = require("esri/Graphic");
import Draw = require("esri/views/draw/Draw");
import MapView = require("esri/views/MapView");
import ToolBar from "./../Toolbar";
import SelectionResultsTable, { drawingPolygon, finalPolygon } from "./SelectionResultTable";
import ToolButton from "./toolButton";
import { clearGraphicType } from "../App/setupView";
import GraphicsLayer = require("esri/layers/GraphicsLayer");

// SelectByRectangleTool

export default class SelectByPolygon extends ToolButton {
  private draw: Draw;
  private drawLayer: GraphicsLayer;
  private selectionResultsTable: SelectionResultsTable;

  constructor(viewIn: MapView, toolbarIn: ToolBar) {
    super(viewIn, toolbarIn);
    this.drawLayer = this.view.map.findLayerById("drawLayer") as GraphicsLayer;
    this.draw = new Draw({ view: viewIn });
    this.selectionResultsTable = new SelectionResultsTable(this);
  }

  deactivateTool() {
    // console.log("measureDistanceTool deactivateTool")
    clearGraphicType(this.view, "selected");
    document.body.style.cursor = "default";
    if (this.draw && this.draw.view && this.draw.activeAction) {
      // if action is active, drawing was never completed, clear graphic
      this.draw.reset();
    }
  }

  // Put widgets on map view
  activateTool(event: any) {
    // console.log("selectByPolygonTool start")
    try {
      this.iconDiv = event.currentTarget;

      if (this.toolbar) {
        this.toolbar.setActiveTool(this as ToolButton);
      }
      if (this.view) {
        // create an instance of draw polyline action
        // the polyline vertices will be only added when
        // the pointer is clicked on the view
        const action = this.draw.create("polygon");
        this.view.focus();
        document.body.style.cursor = "crosshair";

        action.on("vertex-add", ({ vertices }) => this.drawPolygon(vertices, true));
        action.on("cursor-update", ({ vertices }) => this.drawPolygon(vertices, true));
        action.on("vertex-remove", ({ vertices }) => this.drawPolygon(vertices, true));
        action.on("redo", ({ vertices }) => this.drawPolygon(vertices, true));
        action.on("undo", ({ vertices }) => this.drawPolygon(vertices, true));
        action.on("draw-complete", ({ vertices }) => {
          const geometry: Polygon = this.drawPolygon(vertices, false);
          document.body.style.cursor = "default";
          this.draw.reset();
          if (geometry != null) {
            // this.selectionResultsTable.clearUpSelection();
            this.selectionResultsTable.selectFeatures(geometry);
          }
          this.toolbar.setPanAsActiveTool();
        });
      }
    } catch (error) {
      console.error("Error: in selectByPolygonTool " + +error.message);
    }
  }

  private drawPolygon(vertices: any, drawing: any): any {
    // remove existing graphic
    clearGraphicType(this.view, "select");
    if (vertices && vertices.length > 1) {
      const polyVert = vertices.slice(); // create copy for adding back starting point.

      if (polyVert.length > 1) {
        polyVert.push(polyVert[0]);
      }

      // create a new polygon
      const polygon = new Polygon({
        rings: polyVert,
        spatialReference: this.view.spatialReference
      });

      // create a new graphic representing the polygon, add it to the view
      const graphic = new Graphic({
        attributes: { type: "select" },
        geometry: polygon,
        symbol: drawing ? drawingPolygon : finalPolygon
      });

      this.drawLayer.add(graphic);
      return polygon;
    }
    return null;
  }
}
